import React from 'react'

function RecordedBeginnersCourse() {
    return (
        <div>RecordeBeginnersCourse</div>
    )
}

export default RecordedBeginnersCourse;
